import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';

export const useInvoiceLineItemColumns = () => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });

  const invoiceLineItemColumns: GridColumn<any>[] = [
    ...(isBlindReceive
      ? []
      : ([
          {
            field: 'poQty',
            title: 'PO Qty',
            filter: 'numeric',
            format: '',
            dataType: 'number',
            filterFormat: '#',
            step: 1,
          },
          {
            field: 'quantityReceived',
            title: 'Current Receipt Qty',
            filter: 'numeric',
            format: '',
            dataType: 'number',
            filterFormat: '#',
            step: 1,
          },
        ] as GridColumn<any>[])),

    {
      field: 'productItemNum',
      title: 'Item #',
      filter: 'text',
      format: '',
      dataType: 'string',
    },
    {
      field: 'description',
      title: 'Description',
      filter: 'text',
      format: '',
      dataType: 'string',
    },
    {
      field: 'glCd',
      title: 'GL Code',
      filter: 'text',
      format: '',
      dataType: 'string',
    },
    {
      field: 'uom',
      title: 'UOM',
      filter: 'text',
      format: '',
      dataType: 'string',
    },
  ];
  return invoiceLineItemColumns;
};
export default useInvoiceLineItemColumns;
